import { Injectable } from '@angular/core';
import { BehaviorSubject, retry } from 'rxjs';
import * as _ from 'lodash'

@Injectable({
  providedIn: 'root'
})
export class TableService {
  private tableSource = new BehaviorSubject<any>({
    eventColumns: {},
    width: {}
  });
  table = this.tableSource.asObservable();


  private tableDataSource = new BehaviorSubject<any>({});
  tableData = this.tableDataSource.asObservable();

  private tableColumnSource = new BehaviorSubject<any>({});
  tableColumn = this.tableColumnSource.asObservable();

  private tableStyleSource = new BehaviorSubject<any>({
    widths: {}
  });
  tableStyle = this.tableStyleSource.asObservable();
  private sortSource = new BehaviorSubject<any>({});
  sort = this.sortSource.asObservable();
  columnsWidth:any={}

  constructor() { }

  updateTableData(column: any, row: any) {
    let currentValue: any = this.tableDataSource.value;
    const key = row[column.dataKey];
    currentValue[key] = row;
    this.tableDataSource.next(currentValue);
  }

  updateSortedColumn(column: any) {
    let currentValue = this.tableColumnSource.value;
    currentValue[column.dataKey] = column;
    this.tableColumnSource.next(currentValue);
  }

  setEventColumns(tableStaticId:string,columns: any) {
    const values = this.clone(this.tableSource.value)
    values.eventColumns[tableStaticId] = _.filter(this.clone(columns), (column: any) => {
      return column.clickable == true
    }) 
    this.tableSource.next(values)
  }

  clone(data: any) {
    if (data) {
      return JSON.parse(JSON.stringify(data));
    }
    return data;
  }

  updateWidth(key: string, value: number) {
    this.columnsWidth[key] = value;
  }

  getWidth(key: string) {
    // let currentValue: any = this.tableStyleSource.value;
    return this.columnsWidth[key];
  }

  applySort(tableStaticId:string, col: any) {
    let currentValue: any = this.sortSource.value;
    currentValue[tableStaticId] = col;
    this.sortSource.next(currentValue);
  }

  getSortedColumns(tableStaticId:string) {
    const mappedColumns =this.sortSource.value;
    if(mappedColumns[tableStaticId]){
      return mappedColumns[tableStaticId];
    }
    return ;
  }

  getExpandedRows() {
    return this.tableDataSource.getValue();
  }

  getMappedData(tableStaticId:string,data: any, source: any) {
    const columns = _.get(this.tableSource, `value.eventColumns.${tableStaticId}`, [])
    if (!_.isEmpty(source) && !_.isEmpty(data)) {
      return _.map(data, (object: any) => {
        _.each(columns, (column: any) => {
          const key = object[column.dataKey]
          if (!_.isEmpty(source[key])) {
            object.isExpand = _.get(source[key], 'isExpand', false);
          }
        })
        return object;
      })
    } else {
      return _.map(data, (object: any) => {
        object.isExpand = false;
        return object;
      });
    }
  }
}
